import React from "react";
import { AlertTriangle, ArrowRight, Check } from "lucide-react";

const diff = (n) => (n > 0.005 ? `+$${n.toFixed(2)} owed` : n < -0.005 ? `−$${Math.abs(n).toFixed(2)} credit` : "same price");

/**
 * Shown in the date-change review step when an item isn't available for the
 * new dates. Lists same-category alternatives with price difference; the
 * caller re-previews with the chosen replacements.
 */
export const ReplacementPicker = ({ preview, replacements, onPick, testidPrefix = "replacement" }) => {
  if (!preview || preview.availability_ok) return null;
  const chosen = Object.fromEntries((replacements || []).map((r) => [r.from_product_id, r.to_product_id]));
  return (
    <div className="mt-3 rounded-xl border border-red-500/40 bg-red-500/10 p-3 text-left" data-testid={`${testidPrefix}-block`}>
      <p className="text-xs text-red-200 flex items-start gap-2" data-testid={`${testidPrefix}-message`}><AlertTriangle className="w-4 h-4 shrink-0 mt-0.5" /> {preview.unavailable_message || "Some items aren't available for your new dates."}</p>
      {(preview.alternatives || []).map((alt) => (
        <div key={alt.product_id} className="mt-3" data-testid={`${testidPrefix}-item-${alt.product_id}`}>
          <p className="text-xs text-[#F6F1E4] font-medium">{alt.name} × {alt.quantity} — unavailable</p>
          {alt.options.length === 0 ? (
            <p className="text-[11px] text-[#B9C8D5] mt-1">No available alternatives for these dates.</p>
          ) : (
            <div className="mt-1.5 space-y-1.5">
              {alt.options.map((o) => {
                const picked = chosen[alt.product_id] === o.product_id;
                return (
                  <button key={o.product_id} type="button" onClick={() => onPick(alt.product_id, o.product_id)}
                    className={`w-full flex items-center justify-between gap-3 text-left text-xs px-3 py-2 rounded-lg border transition-colors ${picked ? "border-emerald-400/60 bg-emerald-500/10 text-emerald-200" : "border-[#FFD166]/20 text-[#F6F1E4] hover:border-[#FFD166]/50"}`}
                    data-testid={`${testidPrefix}-option-${alt.product_id}-${o.product_id}`}>
                    <span className="inline-flex items-center gap-2 min-w-0"><ArrowRight className="w-3 h-3 shrink-0 opacity-60" /><span className="truncate">{o.name}</span></span>
                    <span className="shrink-0 inline-flex items-center gap-1.5">{diff(o.price_difference)}{picked && <Check className="w-3.5 h-3.5" />}</span>
                  </button>
                );
              })}
            </div>
          )}
        </div>
      ))}
    </div>
  );
};

export default ReplacementPicker;
